import React, { useState } from 'react';
import { Modal, Alert } from 'react-bootstrap';
import { HHIEButton } from '../utility/HHIEButton';
import Loading from '../utility/Loading';

export default function RemoveUserFromRole(props) {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [success, setSuccess] = useState(false);
    const [newCopy, setNewCopy] = useState(null);

    const handleClose = () => {
        setShow(false);
        setLoading(false);
        setSuccess(false);
        setError(false);
        setErrorMessage("");
        if (newCopy !== null) {
            props.setHhieUsers(newCopy);
        }
    };

    const handleShow = () => {
        setShow(true);
    };

    const handleRemove = async () => {
        setLoading(true);
        var requestingUserId = "";
        const userString = sessionStorage.getItem("user");
        if (userString !== null) {
            var user = {};
            try {
                user = JSON.parse(userString);
            }
            catch (ex) {
                console.log("JSONParseUser", ex);
            }
            requestingUserId = user.sfid;
        }
        if (requestingUserId === "") {
            setErrorMessage("DEV ERROR: You are not authenticated anymore for this action.");
            setError(true);
            return;
        }
        let sfid = props.user.id;
        if (sfid === null || sfid === undefined) {
            setErrorMessage("DEV ERROR: Salesforce Id is blank.");
            setError(true);
            return;
        }

        const formData = new FormData();
        formData.append("sfid", sfid);
        formData.append("role", props.role);
        formData.append("userId", requestingUserId);

        const requestOptions = {
            method: 'POST',
            body: formData
        }
        const result = await fetch('api/user/remove-user', requestOptions)
            .then(async (response) => {
                try {
                    const res = await response.json()
                        .then(json => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors);
                            return json.message;
                        });
                    return res;
                }
                catch (ex) {
                    setError(true);
                    setErrorMessage(ex);
                    return console.log("handleRemove json error", ex);
                }
            })
            .catch(ex => {
                setError(true);
                setErrorMessage(ex);
                console.log("handleRemove response error", ex);
            });
        if (!result) {
            setErrorMessage("Couldn't remove user from role.");
            setError(result);
        }
        else {
            setSuccess(result);
            let usersState = [...props.hhieUsers];
            var index = usersState.findIndex(function (usr) {
                return usr.id === sfid;
            });
            if (index !== -1) {
                usersState.splice(index, 1);
                setNewCopy(usersState);
            }
        }
        setLoading(false);
    };

    return (
        <>
            <HHIEButton 
                variant="outline-danger" 
                size="sm"
                onClick={handleShow} 
                title="Remove from Role"
            />
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="lg"
                centered
            >
                {(!success && !error) && <Modal.Header>
                    <Modal.Title>
                        Remove <span style={{ color: '#ff3b3b' }}>{props.user.firstName + " " + props.user.lastName}</span> from Role?
                    </Modal.Title>
                </Modal.Header>}
                <Modal.Body>
                    {loading && <Loading message="Loading please wait. . ." />}
                    {!loading && !success && !error &&
                        <div style={{ textAlign: 'center' }}>
                            Are you sure you want to remove <span style={{ color: '#ff3b3b' }}>{props.user.firstName + ' ' + props.user.lastName}</span> from the HHIE {props.role} role?
                            <br /><br />This user will no longer have access to the system.
                        </div>}
                    {success && !error && <Alert variant="success">Member removed successfully.</Alert>}
                    {!success && error && <Alert variant="danger">{errorMessage}</Alert>}
                </Modal.Body>
                <Modal.Footer style={{
                    margin: 'auto'
                }}>
                    {(!success && !error) && <>
                    <HHIEButton
                        variant="outline-danger"
                        long
                        // style={{ minWidth: "100px", margin: "7px" }}
                        onClick={handleRemove}
                        title="Yes"
                    />
                    <HHIEButton
                        variant="secondary"
                        long="true"
                        // style={{ minWidth: "100px", margin: "7px" }}
                        onClick={handleClose}
                        title="No"
                    />
                    </>}
                    {(success || error) && <HHIEButton onClick={handleClose} title="Close"/>}
                </Modal.Footer>
            </Modal>
        </>
    );
}